import { useEffect, useState } from "react"
import { AdminFooter } from "../../components/adminFooter/adminFooter.component"
import { IdeasReview } from "../../components/IdeasReview/ideasReview.component"
import { Pagination } from "../../components/pagination/pagination.component"
import { getIdeas } from "../../services/admin.service"

export const IdeasReviewList = () => {
    const [ideas, setIdeas] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [ideasPerPage, setIdeasPerPage] = useState(10)

    const changePage = pageNumber => setCurrentPage(pageNumber)

    useEffect(() => {
        const getAllIdeas = async () => {
            const { status, data } = await getIdeas()

            if (status == 200) {
                setIdeas(data)
            }
        }
        getAllIdeas()
    }, [])


    const indexOfLastIdea = currentPage * ideasPerPage
    const indexOfFirstIdea = indexOfLastIdea - ideasPerPage
    const currentIdeas = ideas.slice(indexOfFirstIdea, indexOfLastIdea)

    return (
        <div className="app-content content">
            <div className="content-overlay"></div>
            <div className="header-navbar-shadow"></div>
            <div className="content-wrapper">
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mb-0">IDEAS</h2>
                            <p className="font-lato font-12">{ideas.length} records</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table idea-table font-lato font-12">
                                    <tbody>
                                        {currentIdeas.map((idea) => {
                                            return <IdeasReview key={idea.IDEA_ID} category={idea.CATEGORY} department={idea.DEPARTMENT} ideaId={idea.IDEA_ID} empName={idea.EMP_NAME} status={idea.STATUS} hearts={idea.hearts} likes={idea.likes} dislikes={idea.dislikes} createdDate={idea.createdAt} />
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination itemsPerPage={ideasPerPage} totalItems={ideas.length} changePage={changePage} currentPage={currentPage} />
                        </div>
                    </div>
                    <AdminFooter />
                </div>
            </div>
        </div>
    )
}